import { styled } from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScGamesSliderContainer = styled.div`
  & .slider {
    margin-top: 24px;
  }

  & .title {
    ${typography['headline2']}
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 0;

    & .icon {
      margin-left: 8px;
      display: flex;
      align-items: center;
    }

    @media (${device.mobile}) {
      ${typography['headline2mobile']}
    }
  }
`;
